export const galleryModal = ({ images }) => ({
  images,
  currentIndex: 0,
  isOpen: false,
  next() {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
  },
  prev() {
    this.currentIndex =
      (this.currentIndex - 1 + this.images.length) % this.images.length;
  },
  openImage(index) {
    this.currentIndex = index;
    this.isOpen = true;
  },
});
